import $ from 'jquery';
import 'jquery-ui/ui/widgets/accordion.js';
import AOS from "aos";

$(document).ready(function(){
    /**
     * jQuery UI Accordion
     */
    $('.accordion').accordion({
        active: false,
        collapsible: true,
        heightStyle: "content",
        header: '.accordion__header',
        beforeActivate: function( event, ui ) {
            //$(ui.oldHeader).parents('.accordion__item').removeClass('active');
            //$(ui.newHeader).parents('.accordion__item').addClass('active');
        },
        activate: function( event, ui ) {
            if(!$.isEmptyObject(ui.newHeader.offset())) {
                //$('html:not(:animated), body:not(:animated)').animate({ scrollTop: ui.newHeader.offset().top - headerHeight - 30 }, 'normal');
            }
            AOS.refresh();
        }
    });
});